import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';

const DashboardStyle = styled('div')`
    width: 100%;
    height: 100%;
    display: flex;
    background: var(--sand-100);
    position: fixed;
    .menuDashboard {
        width: 200px;
        flex-shrink: 0;
        display: flex;
        padding: 40px 16px 30px 24px;
        flex-direction: column;
        align-items: center;
        background: var(--burgundy-800);
    }
    .tableDashboard {
        flex: 1;
        min-width: 0;
        padding: 40px 16px 40px 31px;
        .table {
            width: 100%;
            border: 1px solid var(--sand-400);
            background: var(--white);
            border-radius: 8px;
            padding: 24px;
        }
    }
    .LogoIMG {
        width: 150px;
        height: auto;
        align-self: center;
        margin-left: -8px;
    }
    .btnQuotes {
        ${typography.bodyXl}
        width: 100%;
        display: flex;
        justify-content: space-between;
        color: var(--sand-100);
        cursor: pointer;
        align-items: center;
    }
    .avatar {
        box-sizing: border-box;
        min-width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--burgundy-600);
        color: var(--sand-100);
        font-weight: 600;
        font-size: 16px;
        border-radius: 50%;
        margin-right: 10px;
    }
    .iconfile {
        width: 16px;
        height: 16px;
        margin-right: 10px;
    }
    .btnQuotes > .iconfile,
    .btmAdmin > .iconfile {
        margin-right: 0;
        flex-shrink: 0;
    }
    .groupJobTitleAndName {
        display: flex;
        flex-direction: column;
        justify-content: center;
        min-width: 0;
    }
    .btmAdmin {
        width: 100%;
        margin-top: auto;
        display: flex;
        color: var(--sand-100);
        justify-content: space-between;
        cursor: pointer;
        align-items: center;
        .groupBtnQuote {
            flex: 1;
            min-width: 0;
        }
    }
    .groupBtnQuote {
        display: flex;
        align-items: center;
    }
    .nameSeller,
    .position {
        color: var(--sand-100);
        font-weight: 400;
        line-height: normal;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .nameSeller {
        font-size: 16px;
    }
    .position {
        font-size: 12px;
        margin-top: 2px;
    }
    .showNameSeller {
        ${typography.headingXl}
        color: var(--sand-700);
    }

    .menuBtn {
        width: 100%;
        margin-top: 147px;
        padding: 8px 0;
    }
    .ant-btn-default {
        border: none !important;
    }
    .ant-popover-inner-content .logOutBtn {
        cursor: pointer !important;
    }
    .dropdown-content-login {
        ${typography.bodyMd}
        position: fixed;
        left: 200px;
        bottom: 12px;
        display: flex;
        flex-direction: column;
        z-index: 12;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
        background-color: var(--white);
        color: var(--sand-700);
        border: 1px solid var(--sand-400);
        border-radius: 6px;
        margin-bottom: 10px;
        padding: 10px 16px 10px 16px;
        cursor: pointer !important;
    }

    .headerTable {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 40px;
    }

    .version {
        position: absolute;
        bottom: 5px;
        left: 26px;
        font-size: 12px;
        font-style: italic;
        color: var(--sand-400);
    }
    @media screen and (max-width: 768px) {
        .menuDashboard {
            width: 20%;
            padding: 24px 12px 30px 12px;
        }
        .dropdown-content-login {
            left: 20%;
        }
        .LogoIMG {
            width: 100%;
            margin-left: 0;
        }
        .tableDashboard {
            padding: 29px 24px 29px 24px;
        }
    }
`;
export default DashboardStyle;
